import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { COURSE_FEATURE_KEY } from './keys';
import { courseReducer } from './reducers/course.reducer';
import { CourseEffects } from './effects/course.effects';

export function provideCourseStore(): EnvironmentProviders[] {
    return [provideState(COURSE_FEATURE_KEY, courseReducer), provideEffects(CourseEffects)];
}
